import {isClass} from "@cm/utils"
import {z} from "zod/v4-mini"

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()])
type Literal = z.infer<typeof literalSchema>
export type Json = Literal | {[key in string]?: Json} | Json[]
export const jsonSchema: z.ZodMiniType<Json, Json> = z.custom<Json>((data) => {
    const seen = new WeakSet()

    function validate(val: unknown): boolean {
        if (val === null || typeof val !== "object") return literalSchema.safeParse(val).success

        if (Array.isArray(val)) return val.every((item) => validate(item))

        if (isClass(val)) return false

        if (seen.has(val)) return true

        seen.add(val)

        return Object.values(val).every((propVal) => propVal === undefined || validate(propVal))
    }

    return validate(data)
})
